export default __webpack_public_path__ + "static/media/feature-emp-3.e72b45dc.svg";